<template lang="pug">
    .home
      section.landing.p-0
        vue-slick-carousel.h-100(:autoplay="true", :arrows="false", :autoplaySpeed="5000", :pauseOnHover="false", :dots="true", lazyLoad="ondemand", dotsClass="slick-dots custom-dot-class")
          .slide
            .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/home_1.webp)'}")
            b-container.text-center.h-100.center-xy
              .content-area
                h1.text-light Where Curated Art Meets Elevated Design
                h2.text-light.mb-4 Considered collections and art solutions for designers, collectors and thoughtful spaces.
                b-button.btn-glass-light(:to="{name: 'gallery'}") Browse Artworks
          .slide
            .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/home_22.webp)'}")
            b-container.text-center.h-100.center-xy
              .content-area
                h1.text-light From Specification to Installation, Seamlessly Executed
                h2.text-light.mb-4 Transparent pricing, predictable timelines, and service that honours every project.
                b-button.btn-glass-light(:to="{name: 'Consulting'}") Explore Our Services
          .slide
            .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/home_3.webp)'}")
            b-container.text-center.h-100.center-xy
              .content-area
                h1.text-light a Bespoke Selection of Leading Local Artists
                h2.text-light.mb-4 Empowering exceptional emerging and established talent, through exclusive partnerships, and increased exposure.
                b-button.btn-glass-light(:to="{name: 'artists'}") Meet Our Artists
          .slide
            .bg(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/home_4.webp)'}")
            b-container.text-center.h-100.center-xy
              .content-area
                h1.text-light Tailored Solutions To Fit Your Project Needs
                h2.text-light.mb-4 From custom commissions to flexible rental programs, we adapt to your timeline, budget, and client needs.
                b-button.btn-glass-light(:to="{name: 'Consulting'}") How We Work
      section.section-light
        .container
          h2.mb-4 Curator's Picks
          .row
            .col-4.text-left.pb-4(v-for="artist in featuredArtists", :key="artist.id")
              b-button.previewPiece.mx-1(:style="{'background-image': `url(${getImageUrl(artist.preview_piece_url, 350)})`}", :to="{ name: 'gallery', query: { artist: artist.id} }")
              h5.mb-0 {{ artist.name }}
              //- span.text-muted.small {{ artist.name }}
      section.rent(:style="{'background-image': 'url(https://cdn.wallcollective.co/resources/images/home_rental.webp)'}")
        b-container.py-5
          h1 South Africa's Leading Fine Art Rental Service
          h2 Curated art. Flexible ownership.
          ul.text-muted.p-3
            li Rent to purchase opportunities
            li Empowering local artists monthly
            li Keeping your collection fresh
            li Designer-friendly terms
            li No permanent capital commitment
          div.text-center.mt-4
            b-button.btn-glass-dark(:to="{name: 'rentals'}") More About Renting
      section#sectionProject.section-dark.bg-alt-alt
        .container
          .row
            .col-md-6.text-left
              h3 Latest Project Feature
              p A fully curated artwork installation across Rickety Bridge Estate’s hospitality and tasting venues. Our curatorial approach focused on aligning each work with the estate’s architectural language, natural surroundings, and guest journey. By layering original South African artworks throughout the spaces, the installation added texture, narrative, and visual cohesion - enriching the atmosphere while honouring the heritage of this iconic Franschoek destination
              router-link.ul.text-light(:to="{ name: 'consulting' }") BROWSE SERVICE OFFERING
              img.w-100.logo.d-block.mt-5(src="https://cdn.wallcollective.co/resources/images/Rickety_bridge_logo.webp")
            .col-md-6.pt-2
              .row
                .col-6
                  img.w-100(src="https://cdn.wallcollective.co/resources/images/featured_1_new.webp")
                .col-6
                  img.w-100(src="https://cdn.wallcollective.co/resources/images/featured_2_new.webp")
      section.section-light
        .container
          .row
            .col-md-2.pb-3
              a.ul Testimonials
            .col-md-10
              vue-slick-carousel(ref="testCarousel", v-if="testimonials.length > 0", v-bind="carouselSettings")
                div.px-3(v-for="testimonial in testimonials", :key="testimonial.id")
                  .slick-item-content.px-3
                  p.testimonial {{ `"${testimonial.text}"` }}
                  span.small {{ testimonial.name }} , {{ testimonial.title || '' }}
                  span.small.d-block {{ testimonial.firm }}
          div.text-right
              a(@click="nextSlide()")
               i.fa.fa-arrow-right
      //- section.section-alt
        b-container.text-center
          content-loader(:height="7", v-if="alert.loading")
          .container.mt-3(v-if="featuredArtist")
            .row
              .col-md-6.p-3
                img.piece.mx-1(:src="getImageUrl(featuredArtist.preview_piece_url, 300)")
              .col-md-6.center-xy
                .text-left
                  h1 Featured Artist
                  h4.m-0 {{ featuredArtist.name }}
                  p {{ featuredArtist.bio }}
                  a.ul(:to="{ name: 'gallery', query: { artist: featuredArtist.id} }") Browse Their Work
          nothing(v-else="", text="NO FEATURED ARTISTS")
      section.section-alt
        b-container.pl-0.ml-0.text-center
          .row
            .col-md-6.p-3
              img.w-100(src="https://cdn.wallcollective.co/resources/images/Dana_new.webp")
            .col-md-4.center-xy.p-3
              .text-left.p-3
                h1.mb-0 Featured Artist
                h2.mt-0 Dayna-Gay Tate
                p.text-muted
                  | Dayna-Gay Tate is a Cape Town–based painter whose
                  | work drifts between memory, nature, and spirit, using
                  | colour as both language and feeling. Her practice is
                  | intuitive and exploratory, shaped by a deep sensitivity
                  | to place, play, and inner landscapes. Through abstract, organic forms, she creates spaces of rest and wonder,
                  | inviting viewers to slow down and reconnect with
                  | something gentle, joyful, and quietly sacred.
                router-link.ul(:to="{ name: 'gallery', query: { artist: 3} }") Browse Dayna's Work
      section.p-0.bg-black
        .container-fluid
          .row
            .col-md-3.m-0.p-0(v-for="category in categories", :key="category.title")
              router-link.center-xy.cat-link(:to="category.to")
                .preview(:style="{'background-image': `url(${category.img})`}")
                span {{ category.title }}
      section.section-dark
        .container.p-5
          h3 Art That Belongs.
          p.text-muted
            | Most galleries offer beautiful art, but lack flexibility and forward thinking.
            | Most platforms offer convenience, but lack curation and excellent service.
            | We're the only service built specifically for how designers actually work -
            | combining curatorial expertise, flexible procurement options,
            | and technology that streamlines your workflow without sacrificing the white-glove service your projects demand.
            br
            br
            | Whether you're sourcing art for a 200-room hotel, a luxury spec home, or a corporate headquarters,
            | you need a partner who understands both art and your business. That's what we built.
          img.d-none.d-md-block.logo-tilt(src="@/assets/images/branding/logo_icon_light.svg", alt="Wall collective logo")
</template>

<script>
import standardMix from '@/mixins/standardMix';
import { apiService } from '@/services';
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';

export default {
  metaInfo() {
    return { title: 'Wall Collective Fine Arts Marketplace' };
  },
  name: 'Home',
  components: {
    VueSlickCarousel,
  },
  mixins: [standardMix],
  data() {
    return {
      carouselSettings: {
        // autoplay: true,
        autoplaySpeed: 100,
        arrows: false,
        // centerMode: true,
        centerPadding: '20px',
        // focusOnSelect: true,
        // infinite: true,
        slidesToShow: 2,
        // speed: 10000,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 3,
              // infinite: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 2,
              initialSlide: 2,
            },
          },
        ],
      },
      artists: [],
      featuredArtist: {},
      featuredArtists: [],
      banners: [
        'https://cdn.wallcollective.co/resources/backgrounds/banner_1.webp',
        'https://cdn.wallcollective.co/resources/backgrounds/banner_2.webp',
        'https://cdn.wallcollective.co/resources/backgrounds/banner_3.webp',
        // 'https://cdn.wallcollective.co/resources/backgrounds/banner_5.webp',
      ],
      testimonials: [
        {
          id: 1,
          name: 'Madre Meyer',
          title: 'Creative Director',
          firm: 'Ampersand Creative',
          text: 'There is no greater compliment for a designer than a creative collaborator who understands the direction so intuitively that they extend - and elevate - the project without imposing a new voice. Wall Collective’s ability to absorb and respond to creative intent is what makes them exceptional.',
        },
        {
          id: 2,
          name: 'Paul Senyol',
          title: 'Artist',
          text: 'As an artist it has been a pleasure showcasing my pieces and working alongside Wall. Rentals, sales and logistics have been smooth and efficient. Their reliable team and partners always go the extra mile.',
        },
        {
          id: 3,
          name: 'Bianca Minnaar',
          title: 'Senior Designer',
          firm: 'Source IBA',
          text: 'We had an excellent experience collaborating with Wall Collective on a recent project. Their team expertly managed every aspect of the process, from sourcing and commissioning distinctive, one-of-a-kind pieces to overseeing the full procurement and installation. The experience was seamless from start to finish, and the final result was beautifully crafted, thoughtfully executed, and resulted in cohesive, unique spaces that exceeded expectations.',
        },
        {
          id: 4,
          name: 'Matteo Brambilla',
          title: 'CEO',
          firm: 'Red Rocket',
          text: 'Pier Place was a vibrant home for Red Rocket, and every touchpoint of the space reflected the bold culture and values that Rocketeers lived by. This was especially enhanced by the striking art from Wall Collective, which made the space truly come alive. I am delighted to say that the curation ignited a lasting sense of inspiration for our people and guests.',
        },
        {
          name: 'Jeremy Clayton',
          title: 'CEO',
          firm: 'Turnkey Hospitality Partners',
          text: 'The team at the Wall Collective provided us with an extraordinary experience, bringing art into our home in a professional and innovative manner. We were introduced to the artwork through a rental solution, and overall we thoroughly enjoyed the experience, ultimately purchasing the artwork. We hope to work with the Wall team again soon.',
        },
      ],
      categories: [
        {
          title: 'Illustration',
          to: { name: 'gallery', query: { form: 'illustration' } },
          img: 'https://cdn.wallcollective.co/resources/images/cat_illustration.webp',
        },
        {
          title: 'Painting',
          to: { name: 'gallery', query: { form: 'painting' } },
          img: 'https://cdn.wallcollective.co/resources/images/cat_painting_cropped.webp',
        },
        {
          title: 'Print',
          to: { name: 'gallery', query: { form: 'print' } },
          img: 'https://cdn.wallcollective.co/resources/images/cat_print.webp',
        },
        {
          title: 'Photography',
          to: { name: 'gallery', query: { form: 'photography' } },
          img: 'https://cdn.wallcollective.co/resources/images/cat_photography.webp',
        },
      ],
      art: [
        {
          id: 1,
          title: 'Abstract',
          to: { name: 'gallery', params: { form: 'painting', style: 'abstract' } },
          img: 'https://cdn.wallcollective.co/content/abstract.webp',
        },
        {
          id: 2,
          title: 'Pop Art',
          to: { name: 'gallery', params: { style: 'pop-art' } },
          img: 'https://cdn.wallcollective.co/content/pop.webp',
        },
        {
          id: 3,
          title: 'Fine Arts',
          to: { name: 'gallery', params: { style: 'fine-art' } },
          img: 'https://cdn.wallcollective.co/content/fine.webp',
        },
        {
          id: 4,
          title: 'Photography',
          to: { name: 'gallery', params: { form: 'photography' } },
          img: 'https://cdn.wallcollective.co/content/photography.webp',
        },
        {
          id: 7,
          title: 'Portraits',
          to: { name: 'gallery', params: { subject: 'portrait' } },
          img: 'https://cdn.wallcollective.co/content/portrait.webp',
        },
        {
          id: 6,
          title: 'Sculptures',
          to: { name: 'gallery', params: { form: 'sculpture' } },
          img: 'https://cdn.wallcollective.co/content/sculpture.webp',
        },
        {
          id: 5,
          title: 'Drawings',
          to: { name: 'gallery', params: { form: 'drawing' } },
          img: 'https://cdn.wallcollective.co/content/drawing.webp',
        },
        {
          id: 8,
          title: 'Oil Paintings',
          to: { name: 'gallery', params: { form: 'painting', medium: 'oil' } },
          img: 'https://cdn.wallcollective.co/content/oil.webp',
        },
      ],
    };
  },
  methods: {
    prevSlide() {
      this.$refs.testCarousel.prev();
    },
    nextSlide() {
      this.$refs.testCarousel.next();
    },
  },
  async created() {
    try {
      this.loading();
      // Get featured artists
      this.artists = await apiService.getArtists({ is_featured: true });
      this.featuredArtists = this.artists.slice(1, 4) || [];
      this.featuredArtist = this.artists[0] || {};
      this.clear();
    } catch (error) {
      this.error('Could not retrieve artists');
    }
  },
};
</script>

<style lang="scss" scoped>

// .testimonial-dot-class li button:before {
//   opacity: 1; /* Ensure active dot is visible */
//   z-index: 1000000;
//   position: absolute;
//   top: -50px;
//   color: black;
// }
.slide {
  height: 100vh;
  position: relative;
  background-color: black;
  .content-area {
    position: relative;
    z-index: 1;
  }
  .bg {
      background-size: cover;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: .5;
      z-index: 0;
    }
    .content-area {
      max-width: 500px;
    }
}

  // .landing {
  //   position: relative;
  //   z-index: 1;
  //   // min-height: 60vh;
  //   height: 80vh;
  //   @include desktop {
  //     height: 80vh;
  //   }
  //   background-color: black;
  //   .carouselHome {
  //     position: relative;
  //     height: 100%;
  //     .carousel-inner {
  //       position: relative;
  //       height: 100% !important
  //     }
  //   }

  //   .bg {
  //     background-size: cover;
  //     position: absolute;
  //     top: 0;
  //     left: 0;
  //     width: 100%;
  //     height: 100%;
  //     opacity: .9;
  //     z-index: -1;
  //   }
  // }

  #sectionProject {
    .logo {
      max-width: 400px;
    }
  }

    .rent {
    position: relative;
    z-index: 1;
    background-size: cover;
    background-color: black;

    ::before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0.1;
      z-index: -1;
      background-color: white;
    }
  }

  .illustration {
    width: 200px;
  }

    .logo-tilt {
      width: 13rem;
    }
    .thumbnail {
      height: 200px;
      max-width: 31%;
    }
     .cat-link {
      color: white;
      height: 200px;
        min-height: 200px;
        @include desktop {
          height: 50vh;
        }
      .preview {
        position: absolute;
        left: 0;
        top: 0;
        opacity: 0.3;
        height: 100%;
        width: 100%;
        transition: ease-in 0.5s all;
        @include desktop {
          height: 50vh;
        }
          background-size: cover;
        &:hover {
          color: white !important;
          opacity: 1 !important;
        }
        }

      .overlay {
        cursor: pointer;
        @include cover;
        background-color: rgba(white, 0.2);
        opacity: 1;
        transition: ease-in 0.5s all;
        &:hover {
          color: white !important;
          background-color: rgba(#EFE7DB, 0.5);
        }
      }
    }
    .piece {
      width: 100%;
      max-width: 250px;
      // aspect-ratio: 1 / 1;
    }
    .previewPiece {
      width: 100%;
      aspect-ratio: 1 / 1;
      padding-top: 30%;
      background-size: cover;
      background-position: center;
      border-radius: 0 !important;
    }
    // .piece {
    //   position: relative;
    //   .thumbnail {
    //     width: 100%;
    //   }
    //   .overlay {
    //     @include cover;
    //     background-color: rgba(black, 0.5);
    //     opacity: 1;
    //     transition: ease-in 0.5s all;
    //     &:hover {
    //       opacity: 0;
    //     }
    //   }
    // }
</style>



// WEBPACK FOOTER //
// src/components/views/Home.vue